import * as yup from 'yup';

export const createSkinMonitoringDialogSchema = yup.object().shape({
  date: yup.date().required().label('Date'),
  condition: yup.boolean().required().default(false).label('Condition'),
  existing: yup.boolean().required().default(false).label('Existing'),
  description: yup.string().required().default(null).nullable().default(null).label('Description'),
  discussed: yup.boolean().required().default(null).nullable().label('Discussed'),
  solutionAgreement: yup.string().required().default(null).nullable().label('Solution agreement'),
  otherComment: yup.string().required().default(null).nullable().label('Other comment'),
  mediaId: yup.string().required().default(null).nullable().label('Media')
});
